import actionTypes from '../constants/action-types';

const variables = (state = null, action) => {
  if (action.type !== actionTypes.SET_VARIABLES) return state;
  return action.payload.variables;
};

export default variables;
